var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuesticon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_556_6610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.32101 12.2337V11.0685C9.32101 10.4505 9.0755 9.8578 8.63849 9.4208C8.20148 8.98379 7.60878 8.73828 6.99076 8.73828H3.49538C2.87736 8.73828 2.28465 8.98379 1.84765 9.4208C1.41064 9.8578 1.16513 10.4505 1.16513 11.0685V12.2337",
    stroke: "#737373",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.24306 6.40855C6.53002 6.40855 7.57331 5.36526 7.57331 4.0783C7.57331 2.79134 6.53002 1.74805 5.24306 1.74805C3.9561 1.74805 2.91281 2.79134 2.91281 4.0783C2.91281 5.36526 3.9561 6.40855 5.24306 6.40855Z",
    stroke: "#737373",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8164 12.2341V11.069C12.816 10.5527 12.6442 10.0511 12.3278 9.64304C12.0115 9.23498 11.5686 8.94353 11.0687 8.81445",
    stroke: "#737373",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32101 1.82422C9.82226 1.95256 10.2665 2.24407 10.5838 2.6528C10.9011 3.06153 11.0733 3.56423 11.0733 4.08165C11.0733 4.59906 10.9011 5.10176 10.5838 5.51049C10.2665 5.91922 9.82226 6.21074 9.32101 6.33908",
    stroke: "#737373",
    strokeWidth: 1.16513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_556_6610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9815,
    height: 13.9815,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuesticon);
export default __webpack_public_path__ + "static/media/guesticon.604a60234bd2f60af700f1c7a228d595.svg";
export { ForwardRef as ReactComponent };